import { css, cx } from '@emotion/css';
import style from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import ScrollStickyVideo from '@/components/ScrollStickyVideo';
import { createEFPic } from '@/utils/useEFPic';
import { handleDynamicPath } from '@/utils/handleDynamicPath';
const { EFPic } = createEFPic('/media/smarthomepanel/pc/');

export default function AnimationC() {
    const { useState, useLang } = useGlobal();
    const { t } = useLang('smarthomepanel');
    const [flagObj, setFlagObj] = useState({
        flag0: false,
        flag1: true,
        flag2: false,
        flag3: false,
        flag4: false,
    });
    const splitNumObj = {
        n0: 0.01,
        n11: 0.3,
        n1: 0.35,
        n2: 0.65,
        n3: 0.8,
        n4: 1,
    };

    //设置各个过程节点的显隐
    const setParamFromIndex = (index: number) => {
        const flag0 = index >= splitNumObj.n0;
        const flag1 = index >= 0 && index < splitNumObj.n11;
        const flag2 = index >= splitNumObj.n1 && index < splitNumObj.n2;
        const flag3 = index >= splitNumObj.n2 && index < splitNumObj.n3;
        const flag4 = index >= splitNumObj.n3 && index <= splitNumObj.n4;

        setFlagObj({
            flag0: flag0,
            flag1: flag1,
            flag2: flag2,
            flag3: flag3,
            flag4: flag4,
        });
    };

    const onProgress = (progress: number) => {
        // console.log(progress);
        setParamFromIndex(progress);
    };

    return (
        <div
            className={cx(
                style.animationC,
                css`
                    .ScrollStickyVideo-video {
                        width: 720px;
                        margin-left: -12vw;
                    }
                    .ScrollStickyVideo-children {
                        width: 1120px;
                        color: #fff;
                    }
                `,
            )}
        >
            <div id="animationC-trigger-c2"></div>
            <ScrollStickyVideo
                height={100}
                delayRatio={1}
                scrollRatio={2.5}
                onProgress={onProgress}
                url={handleDynamicPath(`/video/smarthomepanel/canvasAni.mp4`)}
                webmUrl={handleDynamicPath(`/video/smarthomepanel/canvasAni.webm`)}
            >
                <div className="item-box">
                    <div className="g-img">
                        <div className="canvas-box">
                            <canvas style={{ width: '100%', height: '100%' }} id="canvas22"></canvas>
                        </div>
                        <div className="canvas-box" id="animationC-canvas"></div>
                        <div className={`canvas-bg canvas-bg1 ${flagObj.flag0 ? 'active' : ''}`}>
                            <div className="canvas-img-bg">
                                <EFPic
                                    name={['img_11_new.webp', 'img_11_new.png']}
                                    // layout="fill"
                                    className="fullImgs"
                                    alt={t('Smart Home Panel')}
                                    // noUseSrcset={true}
                                />
                            </div>
                        </div>
                        <div className={`canvas-bg canvas-bg2 ${flagObj.flag2 ? 'active' : ''}`}>
                            <div className="canvas-img-bg">
                                <EFPic
                                    name={['img_14_new.webp', 'img_14_new.png']}
                                    // layout="fill"
                                    className="fullImgs"
                                    alt={t('Smart Home Panel')}
                                    // noUseSrcset={true}
                                />
                            </div>
                        </div>
                        <div className={`canvas-bg canvas-bg3 ${flagObj.flag3 ? 'active' : ''}`}>
                            <div className="canvas-img-bg">
                                <EFPic
                                    name={['img_13_new.webp', 'img_13_new.png']}
                                    // layout="fill"
                                    className="fullImgs"
                                    alt={t('Smart Home Panel')}
                                    // noUseSrcset={true}
                                />
                            </div>
                        </div>
                        <div className={`canvas-bg canvas-bg4 ${flagObj.flag4 ? 'active' : ''}`}>
                            <div className="canvas-img-bg">
                                <EFPic
                                    name={['img_12_new.webp', 'img_12_new.png']}
                                    // layout="fill"
                                    className="fullImgs"
                                    alt={t('Smart Home Panel')}
                                    // noUseSrcset={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="g-msg">
                        <div className="g-msg-inter">
                            <div className={`msg-line msg-line-a ${flagObj.flag1 ? 'active' : ''}`}>
                                <span className="msg-move">
                                    <span className="color-gray">{t('smart_home_panel.twelve_pc_a_1')} </span>
                                    {t('smart_home_panel.twelve_pc_a_2')}
                                </span>
                                <div className="color-gradient">
                                    <div>{t('smart_home_panel.twelve_pc_a_3')} </div>
                                    <div>{t('smart_home_panel.twelve_pc_a_4')} </div>
                                </div>
                            </div>

                            <div className={`msg-line msg-line-b ${flagObj.flag2 ? 'active' : ''}`}>
                                <span className="msg-move">
                                    <span>{t('smart_home_panel.twelve_pc_b_1')}</span>
                                    <span className="color-gray"> {t('smart_home_panel.twelve_pc_b_2')}</span>
                                </span>
                                <span className="ms-border-line"></span>
                            </div>

                            <div className={`msg-line msg-line-c ${flagObj.flag3 ? 'active' : ''}`}>
                                <span className="msg-move">
                                    <span>{t('smart_home_panel.twelve_pc_c_1')}</span>
                                </span>
                                <span className="ms-border-line"></span>
                            </div>

                            <div className={`msg-line msg-line-d ${flagObj.flag4 ? 'active' : ''}`}>
                                <span className="msg-move">
                                    <span className="color-gray">{t('smart_home_panel.twelve_pc_d_1')} </span>
                                    {t('smart_home_panel.twelve_pc_d_2')}
                                </span>
                                <span className="ms-border-line"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollStickyVideo>
        </div>
    );
}
